import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./index.less";
import bmpLogo from "static/img/bmpLogo.png";
import { request } from "utils.js";
import { DownOutlined,UserOutlined, NotificationOutlined, MenuOutlined} from "@ant-design/icons";
import banerText from "static/img/banerText.png";
import Online from "components/online";
import { Button, Modal, Drawer } from 'antd';


export default function Header(props) {
	let { user } = props;
	const [navLink, setNavLink] = useState([])
	const [showModal, setShowModal] = useState(false);
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 1000);
	const [drawerVisible, setDrawerVisible] = useState(false);

	useEffect(() => {
		const onResize = () => setIsMobile(window.innerWidth <= 1000);
		window.addEventListener('resize', onResize);
		return () => window.removeEventListener('resize', onResize);
	}, []);

	useEffect(() => {
		// 加载【新闻动态|政策法规】
		request({
			method: 'post',
			url: '/aiprt-common-notice-be/pltdynamic/types/lists',
			data: { "isType": '0', status: "1", isIndxShow :"Y"} // 取顶级数据 & 状态:启用 & 首页展示数据
		}).then(res => {
			setNavLink(res.list)
		});
	}, [])
	return (
		<>
			<div className="headerTopBox"></div>
			<div className="header">
				<header className="header-bar">
					<div className="phoneLogo">
						<Link to="/">
							<img src={banerText} />
						</Link>
					</div>
					<div className="header-nav fl">
						<Link to="/">首页</Link>
						<Link to="/notice-more/1/2/1">招采(交易)公告</Link>
						<Link to="/loanlist">金融服务</Link>
						{/* <Link to="/classroom">数智采学堂</Link> */}
						{/* <Link to="/aiask" target="_blank">智能问答</Link> */}
						<Link to='/classroom'>数智采学堂</Link>
						{
							navLink?.map(item => {
								if(item.belongType == '8'){
									// return (<Link key={item.id} to={{ pathname: `/classroom/${item.id}` }}>{item.name}</Link>)
									return (<Link key={item.id} to={{ pathname: `/know/${item.id}/${item.name}` }}>{item.name}</Link>)
								} else{
									return (<Link key={item.id} to={{ pathname: `/news/${item.id}/${item.name}` }}>{item.name}</Link>)
								}
							})
						}
						{/* {user ? <a target="_blank" href="https://aiprt.aipuret.cn/#/">工作平台</a> : ''} */}
						<div className="aboutMenu">
							<Link  to="/about">关于我们</Link>
							<ul>
								<li><Link  to="/about">平台介绍</Link></li>
								<li><Link  to="/property">知识产权</Link></li>
								<li><Link  to="/plantnotice">平台公告</Link></li>
								<li><Link  to="/faq">常见问答</Link></li>
							</ul>
						</div>
						
						<Link to="/help">服务与支持</Link>
						<Link to="/medicalindex">医价数据与分析中心</Link>
						{/* <Link to="/enterprise">会员服务</Link> */}
					</div>

				<div className="header-button">
					{user ? (<>
							<a target="_blank" className="user" href="https://aiprt.aipuret.cn/#/">
								<UserOutlined />{user}
							</a>
							{user ? <a className="goin" target="_blank" href="https://aiprt.aipuret.cn/#/">进入工作台</a> : ''}
							<a className="logout" onClick={() => {
								sessionStorage.setItem('afterLogin', location.href)
								location.href = 'https://aiprt.aipuret.cn/logout?service=' + location.href
							}} >退出</a>
						</>
						) : (
							<div>
								<a onClick={() => {
									sessionStorage.setItem('afterLogin', location.href)
									location.href = 'https://aiprt.aipuret.cn/portal-notice/#/login?redirect='
										+
										// location.href
										'https://aiprt.aipuret.cn/aiprt-bid-opening-be/aiprt/login/userredirect'
								}} >登录</a>
								<div className="header-button-regist">
									<a>登记 <DownOutlined /></a>
									<div className="dengjiBox">
										<div>
											<Link to="/register">供应商登记</Link>
											<Link to="/agencyRegister">代理机构登记</Link>
											<Link to="/purchaserRegister">采购人登记</Link>
											<Link to="/expertRegister">专家登记</Link>
										</div>
									</div>
								</div>
							</div>
						)}
				</div>
				<div className="header-logo"><a href="https://www.yonyou.com/iuap/" target="_blank"><img src={bmpLogo} /></a></div>
				{isMobile && (
					<div className="mobile-menu-btn" onClick={() => setDrawerVisible(true)}>
						<MenuOutlined />
					</div>
				)}
			</header>
			</div>
			<Modal
            title="春节放假通知"
            open={showModal}
            width={1000}
            onCancel={() => setShowModal(false)}
            footer={<>
                <Button type="primary" onClick={() => setShowModal(false)}>{"关闭"}</Button>
            </>}
        	>
				<div>
					各位用户好：AiPRT公共资源数智采平台 2026 年春节放假时间为 2 月 12 日至 2 月 26 日，如有问题可联系值班人员；祝大家春节快乐！<br />
					<h3>一、2026 年春节值班安排</h3>
					<div style={{paddingLeft:'33px'}}>
						2 月 13 日（周五）：梁工<br />
						2 月 14 日（周六）：黄工<br />
						2 月 15 日（周日）：杨工<br />
						2 月 18 日（周三）：邱工<br />
						2 月 19 日（周四）：杨工<br />
						2 月 20 日（周五）：梁工<br />
						2 月 21 日（周六）：黄工<br />
						2 月 22 日（周日）：邱工<br />
						2 月 23 日（周一）：梁工<br />
						2 月 24 日（周二）：黄工<br />
						2 月 25 日（周三）：杨工<br />
						2 月 26 日（周四）：邱工<br />
					</div>
					<h3>二、值班人员联系方式</h3>
					<div style={{paddingLeft:'33px'}}>
						杨工：18074900327<br />
						梁工：13537582759<br />
						黄工：15218649662<br />
						邱工：15879080509<br />
					</div>
					<h3>三、温馨提示</h3>
					<div style={{paddingLeft:'33px'}}>如当天值班人员电话无法接通，可联系其他值班人员。</div>
				</div>
	  </Modal>
		{isMobile && (
			<Drawer
				placement="right"
				closable={true}
				onClose={() => setDrawerVisible(false)}
				open={drawerVisible}
				width="70%"
			>
				<div className="mobile-drawer-menu">
					<div className="mobile-drawer-title">更多服务</div>
					<Link to="/medicalindex" onClick={() => setDrawerVisible(false)}>医价数据与分析中心</Link>
				</div>
			</Drawer>
		)}
		<Online />
		</>
	);
}
